import * as React from 'react'
// libs
import { useSelector } from 'react-redux'
// components
import Grid from '@mui/material/Grid2'
// view components
import CreateReviewForm from 'components/Modals/CreateReviewModal/components/ReviewDetails/components/Form'
import ActivitiesListContainer from 'containers/Activities/components/ActivitiesList'
// view
import {
  BackIcon,
  BackIconWrapper,
  ContentWrapper,
  EditIcon,
  EditIconWrapper,
  Scrollbar,
  TitleWrapper,
  Wrapper
} from './views'
// context
import { Forms, Modals } from 'constants/index'
// graphql
import { REVIEW_ACTIVITIES_LIST_QUERY } from 'graphql/reviews/queries'
// hooks
import { useShowModal } from 'hooks/index'
// context
import { ReviewsListBLContext } from 'containers/Review/ReviewList/layers/BL'
// store
import { objectEntitiesSelector } from 'store/reducers/objectEntities'
// types
import { LogEntityTypes } from 'types/graphql'
// utils
import moment from 'moment'
import { get, orderBy } from 'lodash'
import { generateUserName } from 'utils/user'
import { getPropertyKeyByType } from 'containers/Review/CreateReview/layers/BL'
import { mapReviewPicklistsToFormValues } from 'utils/reviews'

interface IIncomingProps {
  entity: any
  review?: any
  hideModal: () => void
}

const ReviewResult: React.FunctionComponent<IIncomingProps> = ({ entity, hideModal, review }) => {
  const { showModal } = useShowModal({ modalType: Modals.REVIEW_CREATE_MODAL })

  const { myScheduledReviewsFilter } = React.useContext(ReviewsListBLContext)

  const objectEntities = useSelector(objectEntitiesSelector)

  // methods
  const handleShowCreateReviewModal = () => {
    showModal({
      isUpdate: true,
      review,
      entity
    })
    hideModal()
  }

  const objectEntity = objectEntities.find((item) => item.name === getPropertyKeyByType(entity?.entityType))
  const questions = orderBy(objectEntity?.reviewQuestions, 'position')
  const reviewFieldIds = objectEntity?.reviewFieldIds || []
  const picklists = orderBy(
    (objectEntity?.fields || []).filter((field) => reviewFieldIds.includes(field.id)),
    'position'
  )

  // constants
  const initialValues = {
    goals: get(review, 'values.goals'),
    doWell: get(review, 'values.doWell'),
    doBetter: get(review, 'values.doBetter'),
    picklists: mapReviewPicklistsToFormValues(picklists, review)
  }

  const shouldShowEditButton = myScheduledReviewsFilter(review)

  return (
    <Wrapper>
      <Grid container justifyContent={'space-between'}>
        <BackIconWrapper onClick={hideModal}>
          <BackIcon />
        </BackIconWrapper>
        {shouldShowEditButton && (
          <EditIconWrapper
            item
            md={2}
            container
            alignItems={'center'}
            justifyContent={'flex-end'}
            onClick={handleShowCreateReviewModal}>
            <EditIcon />
          </EditIconWrapper>
        )}
      </Grid>

      <Scrollbar>
        <TitleWrapper>
          <span>Review </span>
          <span>{`${review.startPeriod.format('D MMM Y')} to ${review.endPeriod.format('D MMM Y')}`}</span>
          <span>{`Updated by ${generateUserName(review.updatedBy)} on ${moment(review.updatedAt).format(
            'D MMM Y'
          )}`}</span>
        </TitleWrapper>

        <ContentWrapper container direction={'column'}>
          <CreateReviewForm
            isReviewView
            questions={questions}
            picklists={picklists}
            form={Forms.REVIEW_DETAILS_FORM}
            initialValues={initialValues}
          />
          <ActivitiesListContainer
            isReviewDetails
            isReviewView
            disableDrag
            entity={{ id: review.id, entityType: LogEntityTypes.Review }}
            query={REVIEW_ACTIVITIES_LIST_QUERY}
            variables={{
              filter: { entityId: review.id }
            }}
          />
        </ContentWrapper>
      </Scrollbar>
    </Wrapper>
  )
}

export default ReviewResult
